<!-- პირადი ინფორმაცია -->

<div class="filled" [ngClass]="!editModeMap[1] ? 'success' : 'danger'">
  <div class="row align-items-center filled-row justify-content-xs-center" *ngIf="!editModeMap[1]">
    <div class="col filled-title">
      პირადი ინფორმაცია
    </div>
    <div class="col">
      <div class="d-flex flex-column">
        <p>{{this.policy.PersonalInfo.name}} {{this.policy.PersonalInfo.surname}}</p>
        <p>{{this.policy.PersonalInfo.personalNumber}}</p>
        <p>{{this.policy.PersonalInfo.birthDate | date: 'dd/MM/yyyy'}}</p>
      </div>
    </div>
    <div class="col edit-btn">
      <button class="ml-m@s g-b--w0 g g--alignCenter g--nowrap cur-p edit ms-auto d-flex" (click)="onEdit(1)">
        <div class="mr-xs fz-12" style="color: #737373;">ცვლილება</div>
        <i class="fas fa-pen"></i>
      </button>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="row edit-row position-relative" *ngIf="editModeMap[1]">
      <div class="col-lg-2 col-6" *ngIf="form.get('name'); let name;">
        <label for="phone">სახელი</label>
        <input type="text" formControlName="name" class="form-control" id="phone" aria-describedby="emailHelp"
          [ngClass]="{'has-error': !name.valid && submitted}">

      </div>
      <div class="col-lg-3 col-6" *ngIf="form.get('surname'); let surname;">
        <label for="phone">გვარი</label>
        <input type="text" formControlName="surname" class="form-control" id="phone" aria-describedby="emailHelp"
          [ngClass]="{'has-error': !surname.valid && submitted}">

      </div>
      <div class="col-lg-3 col-6 mobile-space col-xs-12" *ngIf="form.get('personalNumber'); let personalNumber;">
        <label for="phone">პირადი ნომერი</label>
        <input type="text" formControlName="personalNumber" class="form-control" id="phone" aria-describedby="emailHelp"
          (keypress)="numberOnly($event)" maxlength="11" [ngClass]="{'has-error': !personalNumber.valid && submitted}">

      </div>
      <div class="col-lg-4 col-6 mobile-space col-xs-12">
        <div class="form-group">
          <label for="phone">დაბადების თარიღი</label>
          <div class="has-datepicker FormInput mb-l ta-l position-relative"
            *ngIf="form.get('birthDate'); let birthDate;">
            <input formControlName="birthDate" type="text" class="form-control" name="birthDate" bsDatepicker
              #dp="bsDatepicker" autocomplete="off" [minDate]="minDate" [maxDate]="maxDate" [readonly]="true" [bsConfig]="{ adaptivePosition: true, containerClass:'theme-default' }"
              [ngClass]="{'has-error': !birthDate.valid && submitted}">
            <i class="fas fa-calendar-alt date-picker" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen"></i>
          </div>
        </div>

      </div>

      <div class="done" (click)="done(1)">
        შენახვა
      </div>
    </div>
  </form>
</div>
<!-- პირადი ინფორმაცია -->
